export const participantsRouter = [
  {
    path: "/labor/participants/list",
    name: "labor-participants-list",
    meta: { title: "参建单位" },
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "@/views/labor/participants/list/index.vue"
      ),
  },
];
